import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; 2025 ThirdWave Microcare Foundation. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
